<script setup>
import { onMounted } from 'vue'
import { storeToRefs } from 'pinia'
import { useRoute } from 'vue-router/dist/vue-router'

import { useCalculationStore } from '@/stores/calculation'
import { useProjectStore } from '@/stores/project'

import CalculationFormDrawer from '@/components/calculation-sidebar/CalculationFormDrawer.vue'
import SpeckleDrawer from '@/components/speckle/SpeckleDrawer.vue'
import CalculationRailDrawer from '@/components/calculation-sidebar/CalculationRailDrawer.vue'

const route = useRoute()

const store = useCalculationStore()
const projectStore = useProjectStore()

const { items } = storeToRefs(useCalculationStore())

onMounted(async () => {
  await projectStore.fetchItem(route.params.id)
  await store.fetchOptions()
  await store.fetchItems({ project: route.params.id })
  const item = items.value.find((item) => item.id === parseInt(route.params.calculationId))
  store.setCurrentItem(item)
})
</script>

<template>
  <CalculationRailDrawer />
  <CalculationFormDrawer />
<!--  <SpeckleDrawer />-->
</template>
